import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GlobalComponentsModule} from '../global-components/global-components.module';
import {SharedComponentsModule} from './presentation/shared-components/shared-components.module';
import {BusinessLogicFacade} from './business-logic/business-logic.facade';
import {BusinessRequirementsInjectionToken} from './presentation/business-logic.requirements';
import { SharedService } from '../lib/shared-service';
import { SchoolPlansModule } from './presentation/school-plans/school-plans.module';
import { SchoolPlansChosenModule } from './presentation/school-plans-chosen/school-plans-chosen.module';


@NgModule({
    imports: [
        BusinessLogicFacade,
        CommonModule,
        GlobalComponentsModule,
        SharedComponentsModule,
        SchoolPlansModule,
        SchoolPlansChosenModule
    ],
    providers: [
        {
            provide: BusinessRequirementsInjectionToken,
            useClass: BusinessLogicFacade
        },
        SharedService
    ],
    exports: []
})
export class SchoolPlansFeatureModule {}
